var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#010101","d":"M37.802,23.247l-26.286-23C11.1-0.116,10.47-0.074,10.105,0.342c-0.363,0.415-0.321,1.047,0.094,1.411\r\n\tL35.624,24L10.199,46.247c-0.416,0.364-0.458,0.996-0.094,1.411C10.303,47.885,10.58,48,10.858,48c0.233,0,0.468-0.081,0.658-0.247\r\n\tl26.286-23c0.216-0.191,0.341-0.465,0.341-0.753S38.019,23.437,37.802,23.247z"}));
}

ArrowRight.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"48px","height":"48px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48","xmlSpace":"preserve"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
